module.exports = __webpack_public_path__ + "img/icon_bluesky.b84bc753.svg";